import { useState } from 'react';
import { Box } from '@mui/material';
import NotificationsList from 'components/common/NotificationsList/NotificationsList';
import PageHeader from 'components/common/PageHeader/PageHeader';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog';
import CustomText from 'components/common/CustomText/CustomText';
import InvitationsPanel from 'components/common/InvitationsPanel/InvitationsPanel';
import { UsersProvider } from 'context/UsersContext';
import { useGetProcedureInvitations } from 'hooks/useProcedure';
import { useGetInvitations } from 'hooks/useUsers';
import { useAuth } from 'context/AuthContext';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';

export default function NotificatoinsPage() {
  const globalStyles = useGlobalStyles();
  const { user } = useAuth();
  const [invitationsOpen, setInvitationsOpen] = useState(false);

  const { data: procedureData } = useGetProcedureInvitations();
  const { data: dashboardData } = useGetInvitations(user.id);
  const invitationsCount = (procedureData?.data?.results?.length ?? 0) + (dashboardData?.doctors?.length ?? 0);

  return (
    <UsersProvider>
      <Box className={globalStyles.container} p={3}>
          <Box>
            <PageHeader
              title={'Notifications'}
              buttons={[
                <CustomButton
                  key="invitations"
                  text="Invitations"
                  variant="outlined"
                  onClick={() => setInvitationsOpen(true)}
                  endIcon={invitationsCount > 0 ? (
                    <Box
                      sx={{
                        minWidth: 18,
                        height: 18,
                        borderRadius: '9px',
                        px: 0.6,
                        backgroundColor: colors.error,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomText
                        text={invitationsCount > 99 ? '99+' : `${invitationsCount}`}
                        fontSize={11}
                        fontWeight={700}
                        color={colors.white}
                      />
                    </Box>
                  ) : undefined}
                />,
              ]}
            />
          </Box>

          <Box mt={3}>
            <NotificationsList />
          </Box>

          <CustomDialog
            open={invitationsOpen}
            title="Invitations"
            onClose={() => setInvitationsOpen(false)}
            width={900}
            content={<InvitationsPanel />}
          />
      </Box>
    </UsersProvider>
  )
}
